import { useState } from "react";

export function useStateLocalStorage<T>(key: string, defaultValue: T): [T, (value: T) => void] {
    const [state, setState] = useState<T>(() => {
        const item = localStorage.getItem(key);
        if (item === null || item === "") return defaultValue;
        try {
            return JSON.parse(item) as T;
        } catch {
            return defaultValue;
        }
    });

    const setValue = (value: T) => {
        if (value === undefined || value === null) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
        setState(value);
    };

    return [state, setValue];
}
